(function () {
  if (window.__nestContactStorePhotoResolution20260625) return;
  window.__nestContactStorePhotoResolution20260625 = true;

  var selector = '.shops-container .shops-container-bottom-left img';
  var targetSize = '1600x';
  var shopifySizePattern = /_(\d+)x(\d*)?(\.(?:jpe?g|png|webp|gif))([?#].*)?$/i;

  function upgradedUrl(url) {
    if (!url || typeof url !== 'string') return url;

    if (shopifySizePattern.test(url)) {
      return url.replace(shopifySizePattern, '_' + targetSize + '$3$4');
    }

    if (/([?&])width=\d+/i.test(url)) {
      return url.replace(/([?&])width=\d+/i, '$1width=1600');
    }

    return url;
  }

  function upgradedSrcset(srcset) {
    if (!srcset) return srcset;

    return srcset.split(',').map(function (candidate) {
      var parts = candidate.trim().split(/\s+/);
      if (!parts[0]) return candidate;
      parts[0] = upgradedUrl(parts[0]);
      return parts.join(' ');
    }).join(', ');
  }

  function upgradeImage(img) {
    if (!img || img.__nestHighResolutionStorePhoto) return;

    var changed = false;
    ['src', 'data-src', 'data-original'].forEach(function (attribute) {
      var value = img.getAttribute(attribute);
      var upgraded = upgradedUrl(value);
      if (upgraded && upgraded !== value) {
        img.setAttribute(attribute, upgraded);
        changed = true;
      }
    });

    ['srcset', 'data-srcset'].forEach(function (attribute) {
      var value = img.getAttribute(attribute);
      var upgraded = upgradedSrcset(value);
      if (upgraded && upgraded !== value) {
        img.setAttribute(attribute, upgraded);
        changed = true;
      }
    });

    if (changed) {
      img.setAttribute('sizes', '(max-width: 749px) calc(100vw - 32px), 980px');
      img.setAttribute('loading', 'eager');
      img.__nestHighResolutionStorePhoto = true;
    }
  }

  function upgradeStorePhotos(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var images = [];

    if (scope.matches && scope.matches(selector)) images.push(scope);
    if (scope.querySelectorAll) {
      images = images.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
    }

    images.forEach(upgradeImage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      upgradeStorePhotos(document);
    }, { once: true });
  } else {
    upgradeStorePhotos(document);
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node && node.nodeType === 1) upgradeStorePhotos(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();